<script>
    import { fade } from 'svelte/transition';
    import Fa from "svelte-fa";
    import SelectImage from "./SelectImage.svelte";
    import { business } from "../../firebase/auth";
    import { faPen } from "@fortawesome/free-solid-svg-icons";
    import Button from '../ui/Button.svelte';

    let edit = false;
</script>


{#if edit === true}
    <SelectImage
        type = "title"
        name = "Titelbild"
        imgSize = {{x: 1440, y: 720}}
        businessId = {$business.id}
        on:cancel={() => {edit = false}}
        on:confirm={() => {edit = false}}
    />
{/if}
<div class="title-img" style="background-image: url({$business.images?.title});">
    <svg width="0" height="0">
        <defs>
          <clipPath id="myClip" clipPathUnits="objectBoundingBox">
            <path d="M 0 0 L 1 0 L 1 1 Q 0.5 0.7 0 1"/>
          </clipPath>
        </defs>
    </svg>
</div>
<div class="edit">
    <Button on:click={() => {edit = true}}>
        <Fa
            icon={faPen}
            slot="icon"
        />
        Bearbeiten
    </Button>
</div>


<style>
    .edit {
        position: absolute;
        top: 0.5rem;
        right: 0;
    }

    .title-img {
        margin-left: -1rem;
        margin-right: -1rem;
        width: calc(100% + 2rem);
        height: 200px;
        background-color: #ebe6e2;
        background-position: center;
        background-size: cover;
        -webkit-clip-path: url(#myClip);
	    clip-path: url(#myClip);
    }
</style>